import { gql } from '@apollo/client';

export const ADD_BLACKLIST_ADDRESSES = gql`
    mutation AddBlacklistAddresses($addresses: String!) {
        addBlacklistAddresses(rawAddresses: $addresses) {
            total
            successCount
            failureCount
            results {
                address
                success
                message
            }
        }
    }
`;

